import { render, staticRenderFns } from "./createCustomer.vue?vue&type=template&id=c9b4e2b4"
import script from "./createCustomer.vue?vue&type=script&lang=js"
export * from "./createCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports